import { Empty } from "antd";
import { FC } from "react";

const EmptyPage: FC = (props) => {
  return <Empty />;
};

export default EmptyPage;
